import * as React from 'react';
import { Typography } from '@material-ui/core';
import { InferenceResult } from '../../models/InferenceResult';

import './InferenceResultView.css';
import { InferenceAdditionalResult } from '../../models/InferenceAdditionalResult';

interface OwnProps {
  result: InferenceResult[];
  additionalResult: InferenceAdditionalResult;
};

export const InferenceResultView: React.SFC<OwnProps> = (props: OwnProps) => {
  if (!props.result || !(props.result.length > 0)) {
    return (<Typography variant="body2">データ無し</Typography>);
  }
  // 追加評価情報
  const additionalLeft = (props.additionalResult.each_position_score || {}).left;
  const additionalTop = (props.additionalResult.each_position_score || {}).top;
  const additionalRight = (props.additionalResult.each_position_score || {}).right;
  const finallyScore = props.additionalResult.finally_score;
  return (
    <div>
      <table style={{ width: '100%',  borderCollapse: 'collapse'}} className="inferenceresulttable">
        <thead>
          <tr>
            <th>観察項目</th>
            {/* <th style={{ width: '90px'}}>重み係数</th> */}
            <th style={{ width: '90px'}}>左肩</th>
            <th style={{ width: '90px'}}>天端</th>
            <th style={{ width: '90px'}}>右肩</th>
          </tr>
        </thead>
        <tbody>
        {
          props.result.map((item, index) =>
            (<tr key={`item_${index}`} className={(index % 2 === 0) ? 'even' : ''}>
              <td>{item.observation_name}</td>
              {/* <td style={{ textAlign: 'center'}}>{item.weight}</td> */}
              <td style={{ textAlign: 'center'}}>{(item.left || {}).predict_label}</td>
              <td style={{ textAlign: 'center'}}>{(item.top || {}).predict_label}</td>
              <td style={{ textAlign: 'center'}}>{(item.right || {}).predict_label}</td>
            </tr>))
        }
          <tr style={{ borderTop: 'solid 3px black' }}>
            <th style={{ textAlign: 'right' }}>左肩、天端、右肩の総合評価点</th>
              <td style={{ textAlign: 'center'}}>{additionalLeft}</td>
              <td style={{ textAlign: 'center'}}>{additionalTop}</td>
              <td style={{ textAlign: 'center'}}>{additionalRight}</td>
          </tr>
          <tr>
            <th style={{ textAlign: 'right' }}>切羽全体の評価点</th>
            <td style={{ textAlign: 'center'}} colSpan={3}>{finallyScore}</td>
          </tr>
        </tbody>
      </table>

    </div>
  );
};




// WEBPACK FOOTER //
// ./src/components/parts/InferenceResultView.tsx